var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "fade" } },
    [
      _vm.overlay
        ? _c(
            "root",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.close,
                  expression: "close"
                }
              ],
              staticClass:
                "list p-6 fixed inset-0 w-full h-full flex items-center justify-center"
            },
            [
              _c(
                "transition",
                { attrs: { name: "fade", mode: "out-in" } },
                [
                  _vm.listView ? _c("client-screen") : _vm._e(),
                  _vm._v(" "),
                  _vm.finishView ? _c("finish-screen") : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }